import React, { useEffect, useState } from "react";
import uuid from "react-uuid";
import {
  Form,
  Switch,
  Tooltip,
  Input,
  Select,
  Avatar,
  Button,
  Space,
} from "antd";
import UserIcon from "../../../../../assets/images/icons/userLogo.svg";
import { toast } from "react-toastify";
import useFormHandlerWorkExp from "../../../../../custom-hooks/useFormHandlerWorkExp";

const { TextArea } = Input;
const MAX_CHARACTERS = 700;

export default function ExperienceRow({
  type,
  index,
  record,
  finalData,
  setFinalData,
  eofOpportunityTitle,
}) {
  const micrositeId = localStorage.getItem("micrositeId");
  const opportunity = type === "VIRTUAL" ? record.virtual : record.faceToFace;

  const [form] = Form.useForm();
  const [isExpanded, setIsExpanded] = useState(false);
  const [mediaType, setMediaType] = useState(null);
  const [mediaPropertyInfo, setMediaPropertyInfo] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [youtubeLink, setYoutubeLink] = useState("");
  const [synthesiaLink, setSynthesiaLink] = useState("");
  const [vimeoLink, setVimeoLink] = useState("");

  const { handleSubmit, loader } = useFormHandlerWorkExp({
    micrositeId,
    eofOpportunityTitle,
  });

  const handleToggle = (checked) => {
    if (isExpanded) {
      setIsExpanded(!isExpanded)
    }


    const isVirtual = type === "VIRTUAL";
    const key = isVirtual ? "virtual" : "faceToFace";
    const opportunityType = isVirtual ? "VIRTUAL" : "FACE_TO_FACE";

    const basePayload = {
      id: record[key].id,
      ...(checked && {
        experienceOfWorkTitleId: record.experienceOfWorkID,
        micrositeId,
        experienceOfWorkOpportunityTitleId: record[key].experienceOfWorkOppID,
      }),
      experienceOfWorkOpportunityInput: {
        toggle: checked,
        opportunityType,
      },
    };

    const formData = new FormData();
    formData.append(
      "experienceOfWorkInput",
      new Blob([JSON.stringify(basePayload)], {
        type: "application/json",
      })
    );

    handleSubmit({
      data: formData,
      id: basePayload.id,
      headerData: finalData,
      setFinalData,
    });
  };

  const handleMediaTypeChange = (value) => {
    setMediaType(value);
    form.setFieldValue("url", "");
    setYoutubeLink("");
    setVimeoLink("");
    setSynthesiaLink("");
    setImagePreview(null);
    setSelectedImageFile(null);
  };

  const handleImageUpload = (e) => {
    getMediaProperty(e)
    const file = e.target.files[0];
    if (file && file.size < 2e6) {
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    } else {
      toast.error("File should not exceed 2MB");
    }
  };


  const getMediaProperty = (event) => {
    let unique_ID = uuid();
    var file = event.target.files[0].name;
    var FT = event.target.files[0].type;
    //Get file name
    var fileArray = file.split(".");
    var fileExt = fileArray[fileArray.length - 1];
    //Get file type
    var fileName = file.split(".").slice(0, -1).join(".");
    var fileType = FT.substr(0, FT.lastIndexOf("/"));

    let data = {
      mediaType: "IMAGE",
      mediaProperty: {
        id: unique_ID,
        name: fileName,
        extension: fileExt,
      },
    };

    setMediaPropertyInfo(data.mediaProperty)

    //     var image = event.target.files[0]; //The image is in binary form
    //     var blob = image.slice(0, image.size); //slice method returns an array
    //     const newFile = new File([blob], `${unique_ID}_${fileName}.${fileExt}`, {
    //         type: `${image.type}`,
    //     }); //The image is still in type "file", not blob or binary 

    //     return { mediaProperty: data, blob: newFile }
  }


  const onSubmit = () => {
    const values = form.getFieldsValue();
    const isVirtual = type === "VIRTUAL";
    const key = isVirtual ? "virtual" : "faceToFace";
    const opportunityType = isVirtual ? "VIRTUAL" : "FACE_TO_FACE";

    if (mediaType === "VIMEO_MEDIA" || mediaType === "SOCIAL_MEDIA") {
      if (!values.url) {
        toast.error("Please enter a valid URL.");
        return;
      }
    }

    if (mediaType === "IMAGE" && !selectedImageFile) {
      toast.error("Please upload an image.");
      return;
    }

    const payload = {
      experienceOfWorkTitleId: record.experienceOfWorkID,
      micrositeId,
      experienceOfWorkOpportunityTitleId: record[key].experienceOfWorkOppID,
      id: record[key].id,
      experienceOfWorkOpportunityInput: {
        toggle: true,
        opportunityType,
        description: values.description,
        media:
          mediaType === null
            ? null
            : {
              mediaType,
              ...(mediaType === "IMAGE"
                ? {
                  mediaProperty: mediaPropertyInfo,
                }
                : {
                  url: values.url,
                }),
            },
      },
    };

    const formData = new FormData();
    formData.append(
      "experienceOfWorkInput",
      new Blob([JSON.stringify(payload)], {
        type: "application/json",
      })
    );

    if (selectedImageFile) {
      formData.append("file", selectedImageFile);
    }

    handleSubmit({
      data: formData,
      id: payload.id,
      headerData: finalData,
      setFinalData,
    });

    setIsExpanded(false);
    // toast.success("Updated successfully");
  };


  useEffect(() => {
    form.setFieldsValue({
      description: opportunity?.description || "",
      mediaType: opportunity?.media?.mediaType || null,
    });
    setMediaType(opportunity?.media?.mediaType || null);
    setImagePreview(opportunity?.media?.url || null);
    setSelectedImageFile(null);
    setMediaPropertyInfo(null);
  }, [record]);

  return (
    <Form
      form={form}
      enctype="multipart/form-data"
      onFinish={onSubmit}
      initialValues={{
        description: opportunity?.description || "",
        mediaType: opportunity?.media?.mediaType || null,
      }}
      style={{ maxWidth: '400px', margin: '0 auto' }}
    >
      <div className="d-flex">
        <Form.Item style={{ marginLeft: "38%" }}>
          <Switch
            defaultChecked={opportunity.toggle}
            onChange={handleToggle}
            checkedChildren="Yes"
            unCheckedChildren="No"
          />
        </Form.Item>

        {opportunity.toggle && (
          <Form.Item>
            <Tooltip title="Click to add/edit more information">
              <p
                style={{ cursor: "pointer" }}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                Add/Edit Details
              </p>
            </Tooltip>
          </Form.Item>
        )}
      </div>

      {isExpanded && (
        <>
          <div className="opportunitiesForm">
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: "Description is required",
                },
                {
                  max: MAX_CHARACTERS,
                  message: `Max ${MAX_CHARACTERS} characters.`,
                },
              ]}
            >
              <TextArea
                rows={2}
                maxLength={MAX_CHARACTERS}
                showCount
                placeholder="Enter Description"
              />
            </Form.Item>


            <Form.Item
              name="mediaType"
              label=" Video or Image">
              <Select
                placeholder="Select Video or Image"
                onChange={handleMediaTypeChange}
                allowClear
              >
                <Select.Option value="VIMEO_MEDIA">Add Vimeo Link</Select.Option>
                <Select.Option value="SOCIAL_MEDIA">
                  Add YouTube Link
                </Select.Option>
                <Select.Option value="SYNTHESIA_MEDIA">Add Synthesia Link</Select.Option>
                <Select.Option value="IMAGE">Upload Image</Select.Option>
              </Select>
            </Form.Item>

            {mediaType === "VIMEO_MEDIA" && (
              <Form.Item
                name="url"
                label="Vimeo Link"
                rules={[
                  {
                    required: true,
                    message: "Vimeo link is required",
                  },
                  {
                    pattern: /^(https?:\/\/)?(www\.)?vimeo\.com\/\d+(\/.*)?$/i,
                    message: "Please enter a valid Vimeo link",
                  },
                ]}
              >
                <Input
                  value={vimeoLink}
                  onChange={(e) => setVimeoLink(e.target.value)}
                  placeholder="Enter Vimeo URL"
                />
              </Form.Item>

            )}

            {mediaType === "SOCIAL_MEDIA" && (
              <Form.Item
                name="url"
                label="YouTube Link"
                rules={[
                  {
                    required: true,
                    message: "YouTube link is required",
                  },
                  {
                    pattern: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/i,
                    message: "Please enter a valid YouTube link",
                  },
                ]}
              >
                <Input
                  value={youtubeLink}
                  onChange={(e) => setYoutubeLink(e.target.value)}
                  placeholder="Enter YouTube URL"
                />
              </Form.Item>

            )}

            {mediaType === "SYNTHESIA_MEDIA" && (
              <Form.Item
                name="url"
                label="Synthesia Link"
                rules={[
                  {
                    required: true,
                    message: "Synthesia link is required",
                  },
                  {
                    // Matches Synthesia video share URLs that contain a valid UUID
                    pattern:
                      /^(https?:\/\/)?(share\.)?synthesia\.io\/[a-zA-Z0-9-]*[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}.*$/,
                    message: "Please enter a valid Synthesia share URL",
                  },
                ]}
              >
                <Input
                value={synthesiaLink}
                  placeholder="Enter Synthesia share URL"
                  // onChange={(e) => form.setFieldValue("url", e.target.value)}
                  onChange={(e) => setSynthesiaLink(e.target.value)}
                

                />
              </Form.Item>
            )}

            {mediaType === "IMAGE" && (
              <Form.Item
                label="Image"
                name="image"
                rules={[
                  {
                    required: true,
                    message: "Please upload an image",
                  },
                  {
                    validator: (_, value) => {
                      if (value || imagePreview || opportunity?.media?.url) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error("Please upload an image"));
                    },
                  },
                ]}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Avatar
                    size={64}
                    src={imagePreview || opportunity?.media?.url || UserIcon}
                    style={{ marginRight: 5 }}
                  />
                  <label className="greenBtn" style={{ padding: 5 }}>
                    Choose File
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        handleImageUpload(e);
                        // manually set the field value so Form knows it has data
                        const file = e.target.files[0];
                        form.setFieldValue("image", file);
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                </div>
              </Form.Item>

            )}

            <Form.Item style={{ textAlign: 'right' }}>
              <Space>
                <Button className="greenBtn" onClick={() => form.submit()}>
                  Save
                </Button>
                <Button
                  className="redSecondaryBtn"
                  onClick={() => {
                    form.resetFields();
                    setIsExpanded(false);
                    setMediaType(null);
                    setSelectedImageFile(null);
                  }}
                >
                  Cancel
                </Button>
              </Space>
            </Form.Item>
          </div>
        </>
      )}
    </Form>
  );
}
